export enum InvokerStatus {
  Visitor = 'Visitor',
  Owner = 'Owner',
  Collaborator = 'Collaborator',
}
